import { Flex, Center, Button } from '@chakra-ui/react';
import { NotificationCard } from '../../components/Card';
import { NotificationTime } from '../../components/Time';
import { decode } from 'js-base64';
import { UsersRight } from '@kula-ai/icons-core';
import { CollapsibleSection, DetailsList } from './components';
import { KText } from '@/ui-library/components';

const ReferralSubmitted = ({ notification = {}, onClose = () => {} }) => {
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));
  const {
    job_name,
    application_candidate_url,
    referrer = {},
    ats_application = {},
  } = data || {};

  const candidateData = [
    { label: 'Name', value: ats_application?.name },
    { label: 'Email', value: ats_application?.email },
  ].filter((item) => item.value);

  const referrerData = [
    { label: 'Name', value: referrer?.name },
    { label: 'Email', value: referrer?.email },
  ].filter((item) => item.value);

  const handleViewCandidate = () => {
    if (application_candidate_url) {
      window.open(application_candidate_url, '_self');
      onClose();
    }
  };

  return (
    <Flex alignItems="baseline" gap="6px">
      <Center minW="34px" h="34px" borderRadius="sm" bg="primary-100">
        <UsersRight
          size={16}
          color="var(--kula-colors-primary-500)"
          className="kula-icon"
        />
      </Center>
      <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start" flex="1">
        <KText>
          A new referral has been submitted for{' '}
          <KText as="span" fontWeight="semiBold">
            {job_name}
          </KText>
        </KText>

        <KText>
          <KText as="span" size="sm-semi-bold">
            Job:{' '}
          </KText>
          <KText as="span" size="sm">
            {job_name}
          </KText>
        </KText>

        <CollapsibleSection title="Candidate details">
          <DetailsList data={candidateData} />
        </CollapsibleSection>

        <CollapsibleSection title="Referrer details">
          <DetailsList data={referrerData} />
        </CollapsibleSection>

        <Button
          variant="primary"
          onClick={handleViewCandidate}
          size="sm"
          w="fit-content"
          data-test-id="view-candidate-button"
        >
          View candidate
        </Button>

        <NotificationTime notification={notification} />
      </Flex>
    </Flex>
  );
};

export const ReferralSubmittedNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <ReferralSubmitted notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
